import React, { Fragment, useMemo, } from "react";
import { classNames } from "./utils/classNames";
import { ColorOptions } from "./types";
export var Card = function (_a) {
    var imageSource = _a.imageSource, title = _a.title, label = _a.label, tag = _a.tag, _b = _a.stacked, stacked = _b === void 0 ? false : _b, children = _a.children, heading = _a.heading, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.profile, profile = _d === void 0 ? {
        alignment: "vertical",
        type: undefined,
        onClick: undefined,
    } : _d, _e = _a.loading, loading = _e === void 0 ? false : _e, extraClass = _a.extraClass, progress = _a.progress, id = _a.id, dataId = _a.dataId, dataTestId = _a.dataTestId, stretchHeight = _a.stretchHeight, onClick = _a.onClick;
    var grid = false;
    if (typeof label == "string") {
        label = {
            text: label,
            color: ColorOptions.Blue,
        };
    }
    if (typeof tag == "string") {
        tag = {
            text: tag,
            color: ColorOptions.Blue,
        };
    }
    if (progress) {
        grid = true;
    }
    var icon = function () {
        switch (!!profile.type && profile.type.toLowerCase()) {
            case "account":
                return "buildings-city";
            case "settings":
                return "cogwheels";
            case "contact":
                return "user";
            default:
                return "cogwheels";
        }
    };
    var renderCardBody = useMemo(function () {
        if (loading) {
            return (React.createElement(Fragment, null,
                title && (React.createElement("span", { className: "placeholder placeholder-h3 animated" })),
                children && (React.createElement("span", { className: "placeholder placeholder-line animated" }))));
        }
        return (React.createElement(Fragment, null,
            title && (profile.alignment !== "vertical" || !profile.type) && (React.createElement("h3", null, profile &&
                (profile.onClick ? (React.createElement("span", { role: "button", onClick: profile.onClick, onKeyPress: profile.onClick, tabIndex: 0 }, title)) : (title)))),
            title && profile.alignment === "vertical" && profile.type && (React.createElement("h2", null, profile &&
                (profile.onClick ? (React.createElement("span", { role: "button", onClick: profile.onClick, onKeyPress: profile.onClick, tabIndex: 0 }, title)) : (title)))),
            children));
    }, [loading, title, children, profile]);
    var onCardClick = disabled || loading || profile.onClick ? undefined : onClick;
    return (React.createElement("div", { id: id, className: classNames("card", stacked && !disabled ? "stacked" : "", disabled ? "disabled" : "", loading ? "loading" : "", !!profile.type
            ? "profile profile-".concat(profile.alignment ? profile.alignment : "vertical")
            : "", extraClass ? extraClass : "", grid ? "card--grid" : "", stretchHeight ? "card--stretchHeight" : ""), role: onCardClick ? "button" : undefined, onClick: onCardClick, "data-id": dataId, "data-testid": dataTestId },
        heading && (React.createElement("div", { className: "card-heading" },
            React.createElement("h3", null, heading))),
        !!profile.type && (!imageSource || loading) && (React.createElement("span", { className: "profile-silhouette" },
            React.createElement("span", { className: "profile-silhouette-icon glyphicon-pro glyphicon-pro-".concat(icon()) }))),
        !!imageSource && !loading ? (React.createElement("div", { className: "card--img" },
            React.createElement("div", { className: "card--img-containter", style: {
                    backgroundImage: "url(".concat(imageSource, ")"),
                } }))) : undefined,
        tag && tag.text && !profile.type && imageSource && (React.createElement("div", { className: classNames("card-tag status-label", tag.color ? tag.color : "lightgrey", tag.extraClass ? tag.extraClass : "") }, tag.text)),
        label && !profile.type && label.text && (React.createElement("div", { className: classNames("card-label status-label", label.color ? label.color : "lightgrey", label.extraClass ? label.extraClass : "") }, label.text)),
        (title || children) && React.createElement("div", { className: "caption" }, renderCardBody),
        progress));
};
